import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUpload = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "33px",
	height: "40px",
	viewBox: "0 0 33 40",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "noun_File_2890045" }),
		/* @__PURE__ */ _jsx("desc", { children: "Created with Sketch." }),
		/* @__PURE__ */ _jsx("g", {
			id: "Wireframes-Web-Agent-Yulia",
			stroke: "none",
			strokeWidth: 1,
			fill: "none",
			fillRule: "evenodd",
			children: /* @__PURE__ */ _jsx("g", {
				id: "Desktop---Dark---Drag-and-Drop-2",
				transform: "translate(-440.000000, -773.000000)",
				fill: "#FBB900",
				fillRule: "nonzero",
				children: /* @__PURE__ */ _jsx("g", {
					id: "noun_File_2890045",
					transform: "translate(440.000000, 773.000000)",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M32.7184977,7.90293042 L25.041156,0.285708328 C24.8595869,0.103984598 24.6114247,0.00111884122 24.3520393,3.10561622e-05 L5.91088979,3.10561622e-05 C4.34333292,-0.00500646453 2.8383483,0.602980406 1.72900177,1.68947047 C0.619655242,2.77596053 -0.0025749275,4.25136029 8.00916937e-06,5.78915129 L8.00916937e-06,34.2204327 C8.00916937e-06,35.7532693 0.620721888,37.2233248 1.72558533,38.3072039 C2.83044878,39.3910831 4.32896518,40 5.89147805,40 L27.1085059,40 C30.3622705,40 32.9999841,37.4123996 32.9999841,34.2204327 L32.9999841,8.57895888 C33.0014594,8.32587383 32.9001784,8.08261957 32.7184977,7.90293042 Z M31.0587942,34.2204327 C31.0587942,36.3606807 29.2901899,38.0956945 27.1085059,38.0956945 L5.89147805,38.0956945 C3.70979404,38.0956945 1.9411897,36.3606807 1.9411897,34.2204327 L1.9411897,5.78915129 C1.9411897,4.76136797 2.3573796,3.77567999 3.09820237,3.04892743 C3.83902514,2.32217488 4.84379644,1.91388955 5.89147805,1.91388955 L23.9443929,1.91388955 L31.0587942,8.95981998 L31.0587942,34.2204327 Z",
						id: "Shape"
					})
				})
			})
		})
	]
});
export default SvgUpload;
